import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styles from './applyList.module.scss';
import { Button } from 'antd-mobile-v5';
import { ApiCore } from '../../api/index';
import { Tabs } from 'antd-mobile-v5';
import assistant_doctor_avatar from '../../static/images_pfizer/assistant/assistant_doctor_avatar.png'
import commissioner from '../../static/images_pfizer/commissioner.png';
import volunteer from '../../static/images_pfizer/volunteer.png';
import nurse from '../../static/images_pfizer/nurse.png';
import team_no_record_yet from '../../static/images_pfizer/team_no_record_yet.png';

const api = new ApiCore();

const CareerType = {
    'VOLUNTEER': '志愿者',
    'NURSE': '护士',
    'DotSPECIALIST': '随访专员'
}

function ApplyList(props: any) {

    const [applyList, setApplyList] = useState([]);
    const [historyList, setHistoryList] = useState([]);
    const [activeKey, setActiveKey] = useState('applyList');
    const [hasTodoList, setHasTodoList] = useState<any>(null);
    const [hasHistoryList, setHasHistoryList] = useState<any>(null);

    useEffect(() => {
        initData();
        return () => {
        }
    }, [])

    const initData = () => {
        const _activeKey = sessionStorage.getItem('ApplyListActiveTabKey');
        if (_activeKey) {
            setActiveKey(_activeKey);
        }
        api.doctorApplyList('todo').then((res: any) => {
            if (res.code == 0) {
                const _data = res.data || [];
                const _hasTodo = (_data.length > 0);
                setHasTodoList(_hasTodo);
                setApplyList(_data);
            }
        });
        api.doctorApplyList('history').then((res: any) => {
            if (res.code == 0) {
                const _data = res.data || [];
                const _hasHistory = (_data.length > 0);
                setHasTodoList(_hasHistory);
                setHistoryList(_data);
            }
        });;
    }

    const tabsChange = (value: any) => {
        sessionStorage.setItem('ApplyListActiveTabKey', value);
        setActiveKey(value);
    }

    const renderText = (status: string | number) => {
        if (status == 1) {
            return '等待中'
        } else if (status == 2) {
            return '已同意'
        } else if (status == 3) {
            return '已拒绝'
        }
        return null;
    }

    const toApplyDetail = (val: any) => {
        props.history.push(`/pfizer/doctor/applyListDetail?id=${val.id}&state=${val.state}`);
    }

    const toHistoryDetail = (val: any) => {
        props.history.push(`/pfizer/doctor/applyListDetail?id=${val.id}&state=${val.state}`);
    }

    return (
        <div className={`${styles.applyList_content}`}>
            <Tabs
                className={styles.outer_form_tab}
                activeKey={activeKey}
                onChange={(value) => { tabsChange(value) }}
                activeLineMode='fixed'
                style={{
                    '--fixed-active-line-width': '35px',
                    '--content-padding': '0',
                }}
            >
                <Tabs.Tab title='申请列表' key='applyList'>
                    <div className={styles.applyListWrap}>
                        {
                            applyList && applyList.map((val: any, key: number) => (
                                <div key={key} className={styles.applyList} onClick={() => { toApplyDetail(val) }}>
                                    <div className={styles.left}>
                                        <img src={val.assistantType == 'VOLUNTEER' ? volunteer : val.assistantType == 'NURSE' ? nurse : commissioner} alt="" />
                                    </div>
                                    <div className={styles.middle}>
                                        <div className={styles.middle_top}>
                                            <div>{val.assistantName}</div>
                                            <div>查看详情</div>
                                        </div>
                                        <div className={styles.middle_bottom}>
                                            <div>
                                                申请成为{val.groupName}的{CareerType[val.assistantType]}
                                            </div>
                                            <div>
                                                {val.createTime ? val.createTime.slice(0, 10) : ''}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                        {
                            hasTodoList && 
                            <div className={styles.todo_no_record_wrap}>
                                <img src={team_no_record_yet} alt="" />
                            </div>
                        }
                    </div>
                </Tabs.Tab>
                <Tabs.Tab title='历史记录' key='hisrotyRecord'>
                    <div className={styles.applyListWrap}>
                        {
                            historyList && historyList.map((val: any, key: number) => (
                                <div key={key} className={styles.applyList}  onClick={() => { toHistoryDetail(val) }}>
                                    <div className={styles.left}>
                                        <img src={val.assistantType == 'VOLUNTEER' ? volunteer : val.assistantType == 'NURSE' ? nurse : commissioner} alt="" />
                                    </div>
                                    <div className={styles.middle}>
                                        <div className={styles.middle_top}>
                                            <div>{val.assistantName}</div>
                                            {
                                                val.state != 3 ?
                                                <div className={styles.agree}>{renderText(val.state)}</div>
                                                :
                                                <div className={styles.reject}>已拒绝</div>
                                            }
                                        </div>
                                        <div className={styles.middle_bottom}>
                                            <div>
                                                申请成为{val.groupName}的{CareerType[val.assistantType]}
                                            </div>
                                            <div>
                                            {val.createTime ? val.createTime.slice(0, 10) : ''}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                            )
                        }
                        {
                            hasHistoryList && 
                            <div className={styles.history_no_record_wrap}>
                                <img src={team_no_record_yet} alt="" />
                            </div>
                        }
                    </div>
                </Tabs.Tab>
            </Tabs>
        </div>
    )

}

export default ApplyList;